import React from "react";
import { Box, Typography } from "@mui/material";
import AvatarSucess from "../../../assets/images/avatar/avatar_afinandinho_sucesso.svg";

const AvatarMessageSucess = ({ t }) => {
  return (
    <Box sx={{ mt: "50px" }}>
      <Box>
        <Typography
          sx={{
            maxWidth: "290px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          {t("global.done_your_new_photo_is_now_on_your_profile")}
        </Typography>
      </Box>
      <img
        src={AvatarSucess}
        alt="success avatar"
        style={{ width: "182px", height: "150px" }}
      />
    </Box>
  );
};

export default AvatarMessageSucess;
